require("./lib/featherlight");
var utils = require('./modules/utils');

/* Event Handlers  */
(function ($, $PB) {
    var scroll_offset = -50;
    var scroll_speed = 1000;

    // Automatically equalize height on specified elements
    $(window).on("load", function () {
        utils.equalHeight('.js-equal-overlay', '.builder-layout');
        utils.equalHeight('.equal');
        $(window).trigger('resize').trigger('scroll');

        setInterval(function() {
            jQuery(window).trigger('resize').trigger('scroll');
        }, 1000);
    });

    //Header top spacer
    $(window).on('resize', function() {
        $('.template, .resource, .archive_wrap, .kmdg-builder-content').css('padding-top',
            $('.site_header').outerHeight()
        );
    });

    $( document ).ready(function() {
        $("#menu-wrapper").mmenu({
            "navbar": {
                "title": mmtitle,
            },
            "extensions": [
                "pagedim-black",
                "theme-dark",
                "position-right"
            ],
            classNames: {
                fixedElements: {
                    fixed: "fix",
                    sticky: "stick"
                }
            }
        });
    });

    $(".single-block").hover(function() {
        var $column = $(this);

        $column.toggleClass('expand');
        $column.find('.inner-block').toggleClass('grayscale');
    });

    $('.builder-layout-marquee-text .marquee').marquee({
        //If you wish to always animate using jQuery
        allowCss3Support: true,
        //works when allowCss3Support is set to true
        css3easing: 'linear',
        //requires jQuery easing plugin. Default is 'linear'
        easing: 'linear',
        //pause time before the next animation turn in milliseconds
        //delayBeforeStart: 1000,
        //'left', 'right', 'up' or 'down'
        direction: 'left',
        //true or false - should the marquee be duplicated to show an effect of continues flow
        duplicated: true,
        //speed in milliseconds of the marquee in milliseconds
        duration: 18000,
        //gap in pixels between the tickers
        gap: 20,
        //on cycle pause the marquee
        pauseOnCycle: false,
        //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
        pauseOnHover: true,
        //the marquee is visible initially positioned next to the border towards it will be moving
        startVisible: false
    });

    $('.builder-layout-marquee-text .marquee').css('visibility', 'visible');

    $( document ).ready(function() {
        $('.builder-layout-full-width-masonry-grid .block-wrap').show();
    });

    $PB('.builder-component-ticker-counter').on('builderAnimationStart', function() {
        console.log('success');
        var $this = $(this),
            $number = $this.find('.single-counter .number'),
            countTo = $number.attr('data-count'),
            delay = $this.attr('data-animation-delay') * 1000;

        setTimeout(function () {
            $({
                countNum: 0
            }).animate({
                    countNum: countTo
                },

                {
                    duration: 3000,
                    easing: 'linear',
                    step: function() {
                        $number.text(commaSeparateNumber(Math.floor(this.countNum)));
                    },
                    complete: function() {
                        $number.text(commaSeparateNumber(this.countNum));
                    }
                }
            );
        }, delay);
    });

    function commaSeparateNumber(val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return val;
    }

    //lity.init($);
    $('.builder-component-image.js-triggers-lightbox .image-container').click(function() {
        console.log($(this).find('img').attr('src'));
        lity($(this).find('img').attr('src'));

    });


    $('.single_accordion .single_accordion__header').on('click', function () {
        var $column = $(this).parent();

        $column.toggleClass('open');
        $column.find('.single_accordion__inner').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });

})(jQuery, KMDGPB.jQuery);